import { Subject } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable()
export class DisplayAfterService {
  private readonly resetSubject = new Subject<void>();
  public readonly reset$ = this.resetSubject.asObservable();

  public reset(): void {
    this.resetSubject.next();
  }
}
